import { render, staticRenderFns } from "./StartupList.vue?vue&type=template&id=67d73ae2&scoped=true"
import script from "./StartupList.vue?vue&type=script&lang=js"
export * from "./StartupList.vue?vue&type=script&lang=js"
import style0 from "./StartupList.vue?vue&type=style&index=0&id=67d73ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d73ae2",
  null
  
)

export default component.exports